import { useState, useEffect } from 'react';
// routes
import { PATH_DASHBOARD } from '../routes/paths';
// axios
import axios from '../utils/axios';
// components
import SvgColor from '../components/svg-color';

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  user: icon('ic_user'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
  banking: icon('ic_banking'),
  blank: icon('ic_blank'),
  blog: icon('ic_blog'),
  booking: icon('ic_booking'),
  calender: icon('ic_calendar'),
  cart: icon('ic_cart'),
  chat: icon('ic_chat'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  file: icon('ic_file'),
  folder: icon('ic_folder'),
  invoice: icon('ic_invoice'),
  kanban: icon('ic_kanban'),
  label: icon('ic_label'),
  locks: icon('ic_lock'),
  mail: icon('ic_mail'),
  menu_item: icon('ic_menu_item'),
  password: icon('ic_password'),
  change_password: icon('ic_change_password'),
  buyer: icon('ic_buyer'),
  seller: icon('ic_seller'),
  relation: icon('ic_relation'),
  approve: icon('ic_approve'),
  group: icon('ic_group'),
  management: icon('ic_management'),
  offer: icon('ic_offer'),
  stock: icon('ic_stock'),
  supplier: icon('ic_supplier'),
  tap_approve: icon('ic_tag_approve'),
  user_group: icon('ic_user_group'),
  credit: icon('ic_credit'),
  user_supplier: icon('ic_user_supplier'),
  user_buyer: icon('ic_user_buyer'),
  user_broker: icon('ic_user_broker'),
  search: icon('ic_search'),
};

// Section icons are intentionally mapped by the database group title instead of PageName.
// PageName is not reliable for menu groups and currently causes several sections to share
// the same fallback icon. This mapping is also consumed by the dashboard landing page.
const GROUP_ICONS = {
  'مدیریت تامین کنندگان': ICONS.supplier,
  'مدیریت تأمین کنندگان': ICONS.supplier,
  'مدیریت انبار مواد اولیه': ICONS.stock,
  'مدیریت تولید': ICONS.management,
  'مدیریت انبار محصولات': ICONS.ecommerce,
  'مدیریت فروش': ICONS.seller,
  'مدیریت مشتریان': ICONS.user_group,
  'مدیریت لجستیک': ICONS.booking,
  'مدیریت نیروی انسانی': ICONS.group,
  'اطلاعات پایه': ICONS.folder,
  'داشبوردها و گزارشات': ICONS.analytics,
  'مدیریت کاربران': ICONS.user,
  'بارگذاری اطلاعات': ICONS.file,
  'تحلیل هوشمند': ICONS.dashboard,
};

const normalizeGroupTitle = (title = '') =>
  title
    .trim()
    .replace(/ي/g, 'ی')
    .replace(/ك/g, 'ک')
    .replace(/[\u200c\u200f]/g, ' ')
    .replace(/\s+/g, ' ');

const getGroupIcon = (groupTitle, pageName) =>
  GROUP_ICONS[normalizeGroupTitle(groupTitle)] || ICONS[pageName] || ICONS.blank;

const useNav = () => {
  const [menu, setMenu] = useState([]);

  const makePath = (path, type) => {
    if (path.includes('.')) {
      const paths = path.split('.');
      const dashboardPath = PATH_DASHBOARD[paths[0]];

      // console.log('Paths => ', paths);
      if (type === 'g') {
        return dashboardPath?.root || PATH_DASHBOARD.underconstruction;
      }
      return dashboardPath?.[paths[1]] !== undefined
        ? dashboardPath[paths[1]]
        : PATH_DASHBOARD.underconstruction;
    }

    return PATH_DASHBOARD[path] !== undefined
      ? PATH_DASHBOARD[path]
      : PATH_DASHBOARD.underconstruction;
  };

  useEffect(() => {
    let titleName = '';
    axios
      .get(`/API/Services/GetUserTree`)
      .then((response) => response.data)
      .then((responseData) => {
        // console.log('1 => ', responseData);
        const menuData = [];
        let childrenData = [];
        let idGroup = 0;
        let keyObject = {};
        let first = true;
        let pathKey = {};
        Object.keys(responseData).forEach((key) => {
          pathKey = responseData[key].PagePath;
          titleName = responseData[key].RollTitle;
          if (first) {
            keyObject = responseData[key];
            idGroup = responseData[key].IdGroup;
            first = false;
          }
          if (responseData[key].IdGroup !== idGroup) {
            idGroup = responseData[key].IdGroup;
            //
            makePath(keyObject.PagePath, 'p');
            //
            menuData.push({
              title: keyObject.GroupTitle,
              path: makePath(keyObject.PagePath, 'g'),
              icon: getGroupIcon(keyObject.GroupTitle, keyObject.PageName),
              children: childrenData,
            });

            keyObject = responseData[key];
            childrenData = [];
          }
          childrenData.push({
            title: responseData[key].PageTitle,
            path: makePath(pathKey, 'p'),
          });
        });

        menuData.push({
          title: keyObject.GroupTitle,
          path: makePath(keyObject.PagePath, 'g'),
          icon: getGroupIcon(keyObject.GroupTitle, keyObject.PageName),
          children: childrenData,
        });

        // console.log('menuData: ', menuData);

        setMenu([
          {
            subheader: titleName,
            items: menuData,
          },
        ]);
      });
  }, []);

  // console.log(' => menu: ', menu);
  return [menu];
};

export default useNav;
